// actions
import { axiosPost }             from 'tsRoot/actions/axios'
import { statusAndErrorMessage } from 'tsRoot/actions/error'
import { notify }                from 'tsRoot/actions/notify'
import { OptionsObject } from 'notistack'
import { deleteCookies } from 'tsRoot/actions/cookie'

// others
import { env, CONST } from 'tsRoot/constants'

export async function preSubmitPersonalContact(
  params: any,
  setSubmitError: React.Dispatch<React.SetStateAction<string>>,
  redirectUrl: string,
  enqueueSnackbar: (message: React.ReactNode, options?: OptionsObject) => React.ReactText,
  pageName?: string,
) {
  try {
    if(env != 'production') {
      console.info(`url: ${`${CONST.API.MY_PAGE_HOST}/api/v1/contacts/personal`}, params: ${JSON.stringify(params,null,'\t')}`)
    }
    const res = await axiosPost(`${CONST.API.MY_PAGE_HOST}/api/v1/contacts/personal`, params)

    setSubmitError('')
    if(pageName) deleteCookies(pageName)
    location.href = redirectUrl

    return res

  } catch (error: any) {
    // Axiosのエラーの場合には通信障害
    if(error && (error.code == 'ERR_NETWORK' || error.code == 'ETIMEDOUT')) {
      return notify(enqueueSnackbar, '登録/更新機能のメンテナンス中です。時間をおいて再度実施してください', 'error')
    }

    const defaultErrorMessage = '登録に失敗しました。運営事務局にご連絡ください'
    /* @ts-ignore */
    const [status, errorMessage] = statusAndErrorMessage(error.response)

    setSubmitError(errorMessage || defaultErrorMessage)
  }
}

export async function preSubmitBusinessContact(
  params: any,
  setSubmitError: React.Dispatch<React.SetStateAction<string>>,
  redirectUrl: string,
  enqueueSnackbar: (message: React.ReactNode, options?: OptionsObject) => React.ReactText,
  pageName?: string,
) {
  try {
    if(env != 'production') {
      console.info(`url: ${`${CONST.API.MY_PAGE_HOST}/api/v1/contacts/business`}, params: ${JSON.stringify(params,null,'\t')}`)
    }

    const res = await axiosPost(`${CONST.API.MY_PAGE_HOST}/api/v1/contacts/business`, params)

    if(pageName) deleteCookies(pageName)
    location.href = redirectUrl

    return res

  } catch (error: any) {
    // Axiosのエラーの場合には通信障害
    if(error && (error.code == 'ERR_NETWORK' || error.code == 'ETIMEDOUT')) {
      return notify(enqueueSnackbar, '登録/更新機能のメンテナンス中です。時間をおいて再度実施してください', 'error')
    }

    const defaultErrorMessage = '登録に失敗しました。運営事務局にご連絡ください'
    /* @ts-ignore */
    const [status, errorMessage] = statusAndErrorMessage(error.response)

    setSubmitError(errorMessage || defaultErrorMessage)
  }
}
